import { cn } from '../../lib/utils'

export const Skeleton = ({ className }) => (
  <div className={cn('animate-pulse rounded-lg bg-border/60', className)} />
)

export const SkeletonCard = () => (
  <div className="bg-surface rounded-xl border border-border p-4 space-y-3">
    <div className="flex items-center gap-3">
      <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3.5 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  </div>
)

export const SkeletonList = ({ count = 4 }) => (
  <div className="space-y-2">
    {Array.from({ length: count }, (_, i) => <SkeletonCard key={i} />)}
  </div>
)

export const SkeletonText = ({ lines = 3 }) => (
  <div className="space-y-2">
    {Array.from({ length: lines }, (_, i) => (
      <Skeleton key={i} className={`h-3.5 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />
    ))}
  </div>
)

export const SkeletonPage = () => (
  <div className="px-4 py-5 space-y-4">
    <div className="flex items-center justify-between">
      <Skeleton className="h-7 w-32" />
      <Skeleton className="h-9 w-24 rounded-xl" />
    </div>
    <SkeletonList count={5} />
  </div>
)
